export default {
    locale_code: 'en_US',
    publication_viewer_shopping_list_label: 'Shopping List',
    publication_viewer_shopping_list_clear_button: 'Clear list',
    publication_viewer_delete_crossed_out_button: 'Delete crossed out items',
    publication_viewer_print_button: 'Print',
    publication_viewer_download_button: 'Download PDF',
    publication_viewer_until_label: 'Through',
    publication_viewer_offer_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_menu_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_expires_in_days_label: '(Expires in {{days}} days)',
    publication_viewer_valid_in_days_label: '(Valid in {{days}} days)',
    publication_viewer_expired_label: '(Expired)',
    publication_viewer_pages_button: 'Pages',
    publication_viewer_offers_button: 'Offers',
    publication_viewer_search_text: 'Search',
    publication_viewer_currency: 'USD',
    publication_viewer_hotspot_picker_header: 'Which offer did you mean?',
    publication_viewer_overview_button: 'Overview',
    publication_viewer_close_label: 'Close',
    publication_viewer_add_to_shopping_list: 'Add to Shopping List',
    publication_viewer_visit_webshop_link: 'Visit Webshop Link',
    publication_viewer_upcoming: 'Upcoming',
    publication_viewer_offer_price_from: 'From',
    publication_viewer_offer_price_for: 'for',
    publication_viewer_offer_valid_from: 'Valid from ',
    publication_viewer_no_product_message: 'No product details',
    publication_viewer_offer_increase_quantity: 'Increase quantity',
    publication_viewer_offer_decrease_quantity: 'Decrease quantity'
};
